import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import loginReducer from "./Reducers/loginReducer";
import addProductReducers from "./Reducers/addProductReducers";
import listedProductReducer from "./Reducers/listedProductReducer";
import  imageUploadReducer from "./Reducers/imageUploadReducer"
import  ordersReducer from "./Reducers/ordersReducer"
import pricingReducer from "./Reducers/pricingReducer";
const reducer = combineReducers({
  loginReducer: loginReducer,
  addProductReducers: addProductReducers,
  listedProductReducer: listedProductReducer,
  imageUploadReducer: imageUploadReducer,
  ordersReducer: ordersReducer,
  pricingReducer: pricingReducer,
});

const middleware = [thunk];

const store = createStore(
  reducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
